import { apiRequest } from "./httpClient";

// full: every mutual friend/group instead of the card's first few.
export async function getProfile(username, { full = false } = {}) {
    return apiRequest(`api/users/profile/${encodeURIComponent(username)}${full ? '?full=1' : ''}`, {
        method: 'GET',
        token: localStorage.getItem('accessToken')
    });
}

// Any of fullName, description, aboutMe, links, profileColors, bannerColor.
export async function patchProfile(fields) {
    return apiRequest('api/users/profile', { method: 'PATCH', token: localStorage.getItem('accessToken'), body: fields });
}

export async function deleteBanner() {
    return apiRequest('api/users/banner', { method: 'DELETE', token: localStorage.getItem('accessToken') });
}
